import { useQuery } from '@tanstack/react-query'
import type { AuthPresentationSurface } from '../../api/generated/model'
import { getPublicAuthPresentation } from '../../api/auth-presentation'

const base = import.meta.env.BASE_URL

export function defaultAuthHero(surface: AuthPresentationSurface, format: 'webp' | 'jpg') {
  return `${base}auth/${surface}-editorial-hero.${format}`
}

export function useAuthPresentation(surface: AuthPresentationSurface) {
  const query = useQuery({
    queryKey: ['public-auth-presentation', surface],
    queryFn: () => getPublicAuthPresentation(surface),
    staleTime: 5 * 60_000,
    retry: 1,
  })
  return {
    heroUrl: query.data?.hero_url ?? defaultAuthHero(surface, 'webp'),
    fallbackUrl: defaultAuthHero(surface, 'jpg'),
    altText: query.data?.alt_text ?? '',
    focalX: query.data?.focal_x ?? 50,
    focalY: query.data?.focal_y ?? 50,
  }
}
